module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"serbay-digital-agency","short_name":"serbay","start_url":"/","background_color":"#4e86eb","theme_color":"#4e86eb","display":"minimal-ui","icon":"src/images/serbay-icon-512x512.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"8bfae992b0a66695b99ab9ef9e44ef09"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
